export default {
  DEFAULT_COLOR: 'blue',
  SELECTED_COLOR: 'red',
  MARKER_RADIUS: 5
}